// A local, tiny fallback, not an editorial photo or a dependency on live Storage.
export const HERO_IMAGE_PLACEHOLDER = '/hero-placeholder.svg';

// Repair only the known retired bundled photo in browser copy caches. Do NOT run
// this on freshly published admin content or rewrite arbitrary editorial URLs.
export function sanitizeCachedSiteText(cached) {
    if (!Array.isArray(cached?.heroGallery)) return cached;
    return {
        ...cached,
        heroGallery: cached.heroGallery.map(photo => {
            let legacy = false;
            try {
                const url = new URL(String(photo?.imageUrl || '').trim());
                const id = '13EGe7Wov0_B-AV0OJp9gDHzxNt5mM4bh';
                legacy = url.hostname === 'drive.google.com' && (
                    url.pathname === '/file/d/' + id + '/view'
                    || (url.pathname === '/thumbnail' && url.searchParams.get('id') === id)
                );
            } catch { /* Preserve unrelated/invalid editor values as before. */ }
            return legacy ? { ...photo, imageUrl: HERO_IMAGE_PLACEHOLDER } : photo;
        })
    };
}

export function handlePresenterImageError(event) {
    const img = event.currentTarget;
    if (img.getAttribute('src') !== HERO_IMAGE_PLACEHOLDER) {
        img.setAttribute('src', HERO_IMAGE_PLACEHOLDER);
    }
}
